import {MP_GET_VENDOR_ITEMS_COMPLETE} from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.vendorItems, action) {
  if (action.type === MP_GET_VENDOR_ITEMS_COMPLETE) {
    return action.payload.vendorItems;
  } else {
    return state;
  }
}
